import { AppFeature } from "features/appFeatures/types/AppFeature";
import { streamingApi } from "./base.api";
import UserSettings from "features/user/types/UserSettings";

const BASE_PATH = "/user";

export const userApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        getMyEnabledFeatures: build.query<
            Record<AppFeature, string | undefined>,
            undefined
        >({
            query: () => `${BASE_PATH}/users/me/Features/enabled`,
        }),
        getMySettings: build.query<UserSettings, undefined>({
            query: () => `${BASE_PATH}/users/me/UserSettings`,
            providesTags: (result) =>
                result ? [{ type: "UserSettings", id: result.userId }] : [],
        }),
        putUserSettings: build.mutation<
            UserSettings,
            {
                userSettings: UserSettings;
            }
        >({
            query: (arg) => ({
                url: `${BASE_PATH}/users/me/UserSettings`,
                method: "PUT",
                body: arg.userSettings,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "UserSettings", id: arg.userSettings.userId },
            ],
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetMyEnabledFeaturesQuery,
    useGetMySettingsQuery,
    usePutUserSettingsMutation,
} = userApi;
